import { escapeRegExp as d, forIn as p } from "lodash-es";
/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.0.3 */
const y = (n, i, u) => {
  const c = d(i), a = new RegExp(c, "i");
  n.length === 0 && console.warn(`No data was passed to the filter function.
    The data argument should be an array of objects`);
  const o = (t, f, s) => {
    if (t?.constant || t?.filterDisabled)
      return !0;
    let r = !1;
    return p(t, (e, l) => {
      typeof e == "function" || e == null || s && !s.includes(l) || (Array.isArray(e) || typeof e == "object" && e !== null ? o(e, f) && (r = !0) : f.test(e) && (r = !0));
    }), r;
  };
  return n.filter((t) => o(t, a, u));
};
export {
  y as f
};
